import { FC } from 'react'
import Link from 'next/link'
import styles from './index.module.scss'
import { IJobBase } from '../../../types'
import { sanitizeUrl } from '../../../utils'
import { JobAttributes } from '../JobAttributes'
import { JobItemContentLabel } from '../JobItemContentLabel'

type Props = {
  job: IJobBase
  hasLink?: boolean
}

export const JobCardContent: FC<Props> = ({ job, hasLink = false }) => {
  const linkToJobDetails = sanitizeUrl(`/jobs/${job?.slug}`)

  return (
    <>
      <p className={styles.title}>
        {hasLink ? (
          <Link href={linkToJobDetails}>
            <a>{job?.title}</a>
          </Link>
        ) : (
          job?.title
        )}
      </p>
      <div className={styles.label}>
        <JobItemContentLabel job={job} />
      </div>
      <div className={styles.attributes}>
        <JobAttributes job={job} />
      </div>
    </>
  )
}
